var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-menu"},[_c('el-menu',{staticClass:"el-menu-demo",attrs:{"default-active":_vm.activeIndex,"mode":"horizontal"},on:{"select":_vm.handleSelect}},_vm._l((_vm.menus),function(menu){return _c('el-menu-item',{key:menu.code,attrs:{"index":menu.code}},[_vm._v(_vm._s(menu.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }